import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  PLATFORM_ID,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { ScreenSizes } from '../../../classes/screen-sizes.class';
import { storyblokImageSizes } from '../../../consts';
import { GROWTHBOOK } from '../../../growthbook';
import { getPictureSourceSizes } from '../../../storyblok/custom-rich-text';
import { getResizeUrl } from '../../../storyblok/get-resize-url';
import { ResizeDirective } from '../../directives/resize.directive';

@Component({
  selector: 'app-picture',
  standalone: true,
  templateUrl: './picture.component.html',
  styleUrls: ['./picture.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [ResizeDirective],
})
export class PictureComponent implements OnChanges {
  @Input() url: string;
  @Input() mobileUrl: string;
  /**
   * Scale of the image between 0 and 1
   */
  @Input() scale: number = 1;
  @Input() width: number;
  @Input() height: number;
  @Input() maxWidth: number;
  @Input() mobileWidth: number;
  @Input() mobileHeight: number;
  @Input() loading = 'lazy';
  @Input() alt: string;

  srcset: string;
  mobileSrcset: string;

  src: string;
  mobileSrc: string;

  sizes: string;

  fetchPriority: 'auto' | 'high' | 'low' = 'auto';
  isMobile = false;

  private platformId = inject(PLATFORM_ID);

  private growthBook = inject(GROWTHBOOK);
  private storyblokUrl = this.growthBook.getFeatureValue('storyblokurl', '//assets.picflow.com');

  private calcImgdata(url: string) {
    const srcset = getPictureSourceSizes(url, this.maxWidth * this.scale).map(
      size => `${getResizeUrl(url, size, this.storyblokUrl)} ${size}w`
    );

    return {
      srcset: srcset.join(', '),
      src: getResizeUrl(url, storyblokImageSizes[storyblokImageSizes.length - 1], this.storyblokUrl),
    };
  }

  ngOnChanges() {
    if (!this.url) return (this.srcset = undefined);
    if (this.loading === 'eager') this.fetchPriority = 'high';
    if (!this.loading) this.loading = 'lazy';

    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = ScreenSizes.screenSize() === 'mobile';
    }

    const { srcset, src } = this.calcImgdata(this.url);

    if (!src.endsWith('.svg')) {
      this.srcset = srcset;
    } else {
      this.srcset = '';
    }

    this.src = src;

    if (this.mobileSrc) {
      const { srcset, src } = this.calcImgdata(this.mobileSrc);
      this.mobileSrcset = srcset;
      this.mobileSrc = src;
    }

    this.sizes = `(max-width: 600px) 100vw, (max-width: ${this.maxWidth}px) ${this.maxWidth * this.scale}px, ${
      this.scale * 100
    }vw`;
  }

  getInSize(src: string, size: number) {
    return getResizeUrl(src, size, this.storyblokUrl);
  }
}
